import { Component, Inject, OnInit, ViewChild,EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DBasicosParametricasServicios, DValorPeriodico } from '@dian/api-basicos-parametricas';
import {DRangosArt241ET} from '@dian-api/renta210v18';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_958';
const VAL_PERIODICO_110 = 110;
const ANNIODECLARACION = 2022;
declare var require: (filename: string) => any;
var BigNumber210 = require('bignumber.js');

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Recibió la pensión de países con convenio?', listHelp: ['733'] },
  { text: "2", active: false, completed: false, tooltip: 'Indique el valor de la pensión del país con convenio', listHelp: ['792'] },
  { text: "3", active: false, completed: false, tooltip: 'Indique el valor de los aportes obligatorios a salud', listHelp: ['661'] },
  { text: "4", active: false, completed: false, tooltip: 'Indique el valor de la renta exenta', listHelp: ['736'] },
  { text: "5", active: false, completed: false, tooltip: 'Impuesto pagado en el país de origen ', listHelp: ['735'] },
  { text: "6", active: false, completed: false, tooltip: 'Recibió la pensión de países sin convenio?', listHelp: ['737'] },
  { text: "7", active: false, completed: false, tooltip: 'Indique el valor total de las pensiones de los países sin convenio', listHelp: ['738'] },
  { text: "8", active: false, completed: false, tooltip: 'Impuestos pagados en los países de origen', listHelp: ['739'] }
];

@Component({
  selector: 'app-renta-pensiones-exterior-modal',
  templateUrl: './renta-pensiones-exterior-modal.component.html',
  styleUrls: ['./renta-pensiones-exterior-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    DBasicosParametricasServicios
  ]
})
export class RentaPensionesExteriorModalComponent extends HandlerModal implements OnInit {

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  showSave:boolean = false;
  disabledCheck = true;
  public UVT:string='';
  private rangosArt241ET: any;

  constructor(
    public dialogRef: MatDialogRef<RentaPensionesExteriorModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    private dBasicosParametricasServicios: DBasicosParametricasServicios,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateBtnRightActive();
    this.validateShowSave();
    this.obtenerValorPeriodico110();
    this.rangosArt241ET = DRangosArt241ET.NUMERAL_1;
/*     this.validateStepHabilitado(1) */
  }

  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cs_id_313 == undefined)this.model.doc.cuerpo.cs_id_313="0";
    if(this.model.doc.cuerpo.cs_id_734 == undefined)this.model.doc.cuerpo.cs_id_734="0";
    if(this.model.doc.cuerpo.cs_id_735 == undefined)this.model.doc.cuerpo.cs_id_735="0";
    if(this.model.doc.cuerpo.cs_id_736 == undefined)this.model.doc.cuerpo.cs_id_736="0";
    if(this.model.doc.cuerpo.cs_id_738 == undefined)this.model.doc.cuerpo.cs_id_738="0";  
    if(this.model.doc.cuerpo.cs_id_739 == undefined)this.model.doc.cuerpo.cs_id_739="0";
    if(this.model.doc.cuerpo.cs_id_733 == undefined)this.model.doc.cuerpo.cs_id_733=null;
    if(this.model.doc.cuerpo.cs_id_737 == undefined)this.model.doc.cuerpo.cs_id_737=null;
    if(this.model.doc.cuerpo.cs_id_740 == undefined)this.model.doc.cuerpo.cs_id_740="0";
    if(this.model.doc.cuerpo.cs_id_661 == undefined)this.model.doc.cuerpo.cs_id_661="0";  
    if(this.model.doc.cuerpo.cs_id_654 == undefined)this.model.doc.cuerpo.cs_id_654="0";
    if(this.model.doc.cuerpo.cs_id_655 == undefined)this.model.doc.cuerpo.cs_id_655="0";
    if(this.model.doc.cuerpo.cs_id_958 == undefined)this.model.doc.cuerpo.cs_id_958="0";
  }

  public operacionCs734():void {
    this.model.doc.cuerpo.cs_id_734 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_734,true);

    const cas734 = this.model.doc.cuerpo.cs_id_734;
    this.model.doc.cuerpo.cs_id_154 = this.model.doc.cuerpo.cs_id_153;
    if ( cas734 != null && cas734 != "" )
    {
      this.operacionCs654();

    }
  }
  
  
 //////////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {
    console.log(this.indexStepper + " - " +val);
    switch (this.indexStepper) {
      case 0://rc15RetiroAhorros?
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_733 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_733 = val;
          }
        }else{
          this.model.doc.cuerpo.cs_id_733 = val;
        }
        //Si ha seleccionado respuesta SI/NO en rc15RetiroAhorros habilitar botón next
        if(val!=undefined && val!=""){
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 5://rc110RentasPasivas?
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_737 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_737 = val;
          }
          this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
          this.updateIndicadorAvance();
          this.validateShowSave();
        }else{
          this.model.doc.cuerpo.cs_id_737 = val;
        }
        //Si ha seleccionado respuesta SI/NO en rc110RentasPasivas habilitar botón next
        if(val!=undefined && val!="" && val!="0"){
          this.buttonRight.nativeElement.disabled = false;
        }else{
          this.buttonRight.nativeElement.disabled = true;

        }
        break;
    }
    console.log(this.model);
  }

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    switch(indexQuestion){
      case 0: //Pregunta Recibio pension de paises con convenio 
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_734, "0") || 
        this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_735, "0") ||
        this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_661, "0") ||
        this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_736, "0")){
          hasValues=true;
        }
        break;
      case 5: //Pregunta Recibio pension de paises sin convenio 
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_738, "0") || 
        this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_739, "0")){
          hasValues=true;
        }
        break;
    }
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    switch(indexQuestionModal){
      case 0://Pregunta Recibio pension de paises con convenio 
        this.model.doc.cuerpo.cs_id_734="0";
        this.model.doc.cuerpo.cs_id_735="0";
        this.model.doc.cuerpo.cs_id_661="0";
        this.model.doc.cuerpo.cs_id_736="0";
        this.model.doc.cuerpo.cs_id_654="0";
        this.model.doc.cuerpo.cs_id_313="0";
        break;
      case 5://Pregunta Recibio pension de paises sin convenio 
        this.model.doc.cuerpo.cs_id_738="0";
        this.model.doc.cuerpo.cs_id_739="0";
        this.model.doc.cuerpo.cs_id_655="0";
        this.model.doc.cuerpo.cs_id_740="0";
        break;
      default:
        break;
    }
    console.log(this.model);
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    
    //Si no ha respondido en rc15RetiroAhorros no puede saltar preguntas
    if( (indexS>=1 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_733==undefined || this.model.doc.cuerpo.cs_id_733=="")) ){
      habilitado = false;
    }
    //Si responde 'NO' en rc15RetiroAhorros debe saltar preguntas del indexStepper 
    else if( (indexS>=1 && indexS<=4  && (this.model.doc.cuerpo.cs_id_733=="0")) ){
      habilitado = false;
    }

    //Si no ha respondido en rc110RentasPasivas no puede saltar preguntas
    if( (indexS>6 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_737==undefined || this.model.doc.cuerpo.cs_id_737=="")) ){
      habilitado = false;
    }
    //Si responde 'NO' en rc110RentasPasivas debe saltar preguntas del indexStepper 
    else if( (indexS>=6 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_737=="0")) ){
      habilitado = false;
    }

    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){
    switch(this.indexStepper){
      case 0:
        //Si no se ha seleccionado respuesta SI/NO en rc15RetiroAhorros deshabilitar botón next
        if( this.model.doc.cuerpo.cs_id_733==undefined || this.model.doc.cuerpo.cs_id_733=="" ){
          this.buttonRight.nativeElement.disabled = true;  
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 5:
        //Si no se ha seleccionado respuesta SI/NO en rc110RentasPasivas deshabilitar botón next
        if( this.model.doc.cuerpo.cs_id_737==undefined || this.model.doc.cuerpo.cs_id_737=="" || this.model.doc.cuerpo.cs_id_737=="0"){
          this.buttonRight.nativeElement.disabled = true;  
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      default:
        if (this.indexStepper === stepsList.length - 1) {
          this.buttonRight.nativeElement.disabled = true;
        } else {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
    }
    
  }
  


  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper>=this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    let indexS = this.indexStepper;
    while(!this.validateStepHabilitado(indexS)){
      if(direction==DirectionType.previous ){
          indexS--;
      }
      if(direction==DirectionType.next){
          indexS++;
      }
    }
    this.changeStepLocal(indexS, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ 
      this.showSave=true 
    };
  }

  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
     
      case 734:
        this.operacionCs734();
        break;
      case 661:
        this.operacionCs661();
        break;      
      case 736:
        this.operacionCs736();
        break;       
      case 735:
          this.operacionCs735();
      break;
      case 738:
        this.operacionCs738();
        break;        
      case 739:
          this.operacionCs739();
          break;    
     
   }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";
    
  }

  operacionCs738(){
    this.model.doc.cuerpo.cs_id_738 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_738,true);

  }

  operacionCs733() {
    const cas733 = this.model.doc.cuerpo.cs_id_733;
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas733,"0")) {
      this.model.doc.cuerpo.cs_id_734=0;
      this.model.doc.cuerpo.cs_id_735 = "0";
      this.model.doc.cuerpo.cs_id_661 = "0";
      this.model.doc.cuerpo.cs_id_736 = "0";
      this.model.doc.cuerpo.cs_id_654 = "0";
      this.model.doc.cuerpo.cs_id_313 = "0";
    }
  }
  
  
  operacionCs661(){
    this.model.doc.cuerpo.cs_id_661 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_661,true);
    const cas736 =  this.model.doc.cuerpo.cs_id_736;
    const cas661 =  this.model.doc.cuerpo.cs_id_661;

    const camposResta = ['cs_id_734','cs_id_661'];	
    const resta734_661  = this.operarCamposCuerpo(DTipoOperacionAritmetica.RESTA,this.model,camposResta, true);
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,  cas736, resta734_661)){
      this.dNotificacionServicio.mostrarDialogoInformacion('El valor de la renta exenta digitado  no pude superar el valor de la renta líquida (Valor de la pensión - Aportes obligatorios de salud). ');
      this.model.doc.cuerpo.cs_id_661 = 0;
    }if ( cas661 != null && cas661 != "" && cas661 != "0")
    {
      this.operacionCs654();

    }


/**
      const camposSuma = ['cs_id_661','cs_id_736'];	
      const suma661_736 = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA,this.model,camposSuma, true);
    
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma661_736, this.model.doc.cuerpo.cs_id_734)){
        this.dNotificacionServicio.mostrarDialogoInformacion('La suma del valor de sus aportes obligatorios a salud y valor de la renta exenta no puede ser mayor que ingresos por pensión');
        this.model.doc.cuerpo.cs_id_661 = 0;
    }
     */
  }
  
  operacionCs736(){
    this.model.doc.cuerpo.cs_id_736 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_736,true);
    const cas736 = this.model.doc.cuerpo.cs_id_736;
      const camposSuma = ['cs_id_661','cs_id_736'];	
    const suma661_736 = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA,this.model,camposSuma, true);
    
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma661_736, this.model.doc.cuerpo.cs_id_734)){
        this.dNotificacionServicio.mostrarDialogoInformacion('La suma del valor de sus aportes obligatorios a salud y valor de la renta exenta no puede ser mayor que ingresos por pensión');
        this.model.doc.cuerpo.cs_id_736 = 0;
      }else if(cas736 != null && cas736 != "" ){
          this.operacionCs654();

        }
  }
  
  operacionCs735(){
    this.model.doc.cuerpo.cs_id_735 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_735,true);
    const cas735 = this.model.doc.cuerpo.cs_id_735 ;
    if(cas735 != null && cas735 != "" ){
      this.operacionCs654();
    }
  }
  
  operacionCs654(){

  
    const cas735 = this.model.doc.cuerpo.cs_id_735;	
    const cas734 = this.model.doc.cuerpo.cs_id_734;	
    if (cas734 == null  ||   cas734 == "" ){
      return;
    }
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas734,"0")) {
      this.model.doc.cuerpo.cs_id_654 = 0;
      this.model.doc.cuerpo.cs_id_313 = 0;
    } else {
      const camposSuma = ['cs_id_661','cs_id_736'];	
      const suma661_736 = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA,this.model,camposSuma, true);
      let base = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,cas734,suma661_736);
      base = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,base,"0")?"0":base;
      const valorEnUvt = this.convertirPesosUvt(base);
      let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ET);
      resultado = this.dutilidades.redondearValorMoneda(resultado, true);
     // const valor = Buscar(base,Tabla art_241);
      this.model.doc.cuerpo.cs_id_654 = resultado;
    
      this.operacionCs313();		
    }
  }
  
  operacionCs313(){
    const cas735 = this.model.doc.cuerpo.cs_id_735;
    const cas654 = this.model.doc.cuerpo.cs_id_654;
    
  
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas735,cas654)) {
      this.model.doc.cuerpo.cs_id_313 = cas735;
    } else {
      this.model.doc.cuerpo.cs_id_313 = cas654;
    }
  }
  
  
  operacionCs737() {
    const cas737 = this.model.doc.cuerpo.cs_id_737;
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas737,"0")) {
      this.model.doc.cuerpo.cs_id_738 = "0";
      this.model.doc.cuerpo.cs_id_739 = "0";
      this.model.doc.cuerpo.cs_id_655 = "0";
      this.model.doc.cuerpo.cs_id_740 = "0";
    }
  }
  
  operacionCs739(){
    this.model.doc.cuerpo.cs_id_739 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_739,true);

    this.operacionCs655();
  }
  
  operacionCs655(){
  
    const cas739 = this.model.doc.cuerpo.cs_id_739;	
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas739,"0")) {
      this.model.doc.cuerpo.cs_id_655 = 0;
      this.model.doc.cuerpo.cs_id_740 = 0;
    } else {
      const base = this.model.doc.cuerpo.cs_id_738;	
    
      const valorEnUvt = this.convertirPesosUvt(base);
      let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ET);
      resultado = this.dutilidades.redondearValorMoneda(resultado, true);
      this.model.doc.cuerpo.cs_id_655 = resultado;
    
      this.operacionCs740();		
    }
  }
  
  operacionCs740(){
    const cas739 = this.model.doc.cuerpo.cs_id_739;
    const cas655 = this.model.doc.cuerpo.cs_id_655;
    
  
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas739,cas655)) {
      this.model.doc.cuerpo.cs_id_740 = cas739;
    } else {
      this.model.doc.cuerpo.cs_id_740 = cas655;
    }
  }
   /**
    * @desc Funcion para obtener los valores del modelo e operar con ellos
    * @param {DTipoOperacionAritmetica} operacion
    * @param {DDocumento} modelo
    * @param {Array<string>} campos
    * @param {boolean} formatear
    * @return {String}
    */
    protected operarCamposCuerpo(operacion: DTipoOperacionAritmetica, modelo: DDocumento, campos: Array<string>, formatear: boolean): string {                    
      let valores = [];
      for (let i in campos) {
          if (this.dutilidades.validarValorNumerico(modelo.doc.cuerpo[campos[i]])) {
              let valor = this.dutilidades.redondearValorMoneda(modelo.doc.cuerpo[campos[i]]);            
              valores.push(valor);
              //valores.push(modelo.doc.cuerpo[campos[i]]);
          } else {
              valores.push('0');
          }
      }
      return this.dutilidades.ejecutarOperacionMultipleValores(valores, operacion, formatear);
  }
  //UVT 
  private obtenerValorPeriodico110(): void {
    this.dBasicosParametricasServicios.obtenerValorPeriodico(VAL_PERIODICO_110, ANNIODECLARACION).subscribe(
      data => this.setObjectFromResponse(data),
      error => console.log(error)
    )
  }
  private setObjectFromResponse(data: any): void {
    
        let model=<DValorPeriodico>data;
        this.UVT = String(model.valor);
     
  }
  private convertirPesosUvt(valorPesos) {
    valorPesos = this.dutilidades.deshacerFormatoMoneda(valorPesos);
    let valorOperacion = new BigNumber210(valorPesos);
    let uvt2023 = "38004";
    if (this.UVT == null  ||  this.UVT == ""  || this.UVT == "0"){

      this.UVT = uvt2023
    }
    valorOperacion = valorOperacion.div(this.UVT);
    valorOperacion = valorOperacion.toFormat();
    const punto = valorOperacion.indexOf(".") + 1;
    if ((punto > 0) && (valorOperacion.length - punto) > 2)
      valorOperacion = valorOperacion.slice(0, -1);
    return String(valorOperacion);
  }

  private aplicarTablaArt241ET(baseGravable, rangos) {
    let desde: boolean = false;
    let hasta: boolean = false;

    for (let i = 0; i < rangos.length; i++) {
      desde = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, baseGravable, rangos[i].desde);
      if ((i + 1) < rangos.length) {
        hasta = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, baseGravable, rangos[i + 1].desde);
      } else {
        hasta = true;
      }
      if (desde && hasta) {
        let resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, baseGravable, rangos[i].desde);
        resultadoResta = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,resultadoResta,"0")?"0":resultadoResta;
        let resultadoMultiplicacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoResta, rangos[i].tarifa);
        const punto = resultadoMultiplicacion.indexOf(".");
        if (punto != -1) {
          resultadoMultiplicacion = resultadoMultiplicacion.substring(0, punto + 3);
        }
        const resultadoSuma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoMultiplicacion, rangos[i].impuesto);
        const resultadoOperacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoSuma2, this.UVT);
        return resultadoOperacion;
      }
    }
    return "0";
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/renta-pensiones/renta-pensiones-exterior-modal/renta-pensiones-exterior-modal.component.ts